/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';
import { useEffect, useRef, useState } from 'react';

import { randomUUID } from 'js/lib/uuid';

// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import CodeBlockV2 from 'bundles/code-evaluator/components/CodeBlockV2';
import { type Props } from 'bundles/code-evaluator/components/CodeBlockV2';

export const CodeblockWithReadOnlyHandler = (props: Props) => {
  const readOnly = props.readOnly;
  const [key, setKey] = useState(randomUUID());
  const initialLoad = useRef(true);

  useEffect(() => {
    if (!initialLoad.current) {
      setKey(randomUUID());
    }
    initialLoad.current = false;
  }, [readOnly]);

  return <CodeBlockV2 key={key} {...props} />;
};
export default CodeblockWithReadOnlyHandler;
